import { createContext, useContext, useState } from "react";
import { authenticateApp } from "./auth-context";

interface ICartContext {
  bloodTests: {
    recommended: any[];
    other: any[];
  };
  setBloodTests: (tests: { recommended: any[]; other: any[] }) => void;
}

export const cartContext = createContext<ICartContext | undefined>(undefined);

const useCartProvider = () => {
  const { clinicUserId } = authenticateApp(); // Keeping this in case it's needed
  const [bloodTests, setBloodTests] = useState<any>({
    recommended: [],
    other: [],
  });

  return {
    bloodTests,
    setBloodTests,
  };
};

interface Props {
  children: React.ReactNode;
}

export const CartProvider = ({ children }: Props) => {
  const app = useCartProvider();

  return <cartContext.Provider value={app}>{children}</cartContext.Provider>;
};

export const appCartState = () => {
  const context = useContext(cartContext);
  if (!context) {
    throw new Error("appCartState must be used within a CartProvider");
  }
  return context;
};
